module.exports = __webpack_public_path__ + "static/media/profesionalism1.259966de.svg";